import PropTypes from "prop-types";
import React from "react";
import { FormFeedback, FormGroup, Input, Label, Modal, ModalBody } from "reactstrap";

const CancelOrder = ({ show, onDeleteClick, onCloseClick,remarks,setRemarks,setTouched,touched,isInvalid }) => {
  return (
   <Modal isOpen={show} toggle={onCloseClick} centered>
      <ModalBody className="px-4 py-4 text-center">
        <div className="d-flex flex-column align-items-center">
        

          <h4 className="mt-3 fw-semibold">Are you sure?</h4>
          <p className="text-muted mb-3">
            Do you really want to remove this record? This action cannot be undone.
          </p>

          <FormGroup className="w-100 text-start">
            <Label for="remarks" className="fw-medium">Remarks <span className="text-danger">*</span></Label>
            <Input
              id="remarks"
              type="textarea"
              rows={4}
              placeholder="Enter remarks..."
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              onBlur={() => setTouched(true)}
              invalid={isInvalid}
            />
            <FormFeedback>Remarks is required.</FormFeedback>
          </FormGroup>

          <div className="d-flex gap-2 justify-content-center mt-4 w-100">
            <button
              type="button"
              className="btn btn-light w-50"
              onClick={onCloseClick}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger w-50"
              onClick={onDeleteClick}
            >
              Yes, Confirm
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

CancelOrder.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
};

export default CancelOrder;
